module.exports = __webpack_public_path__ + "static/img/slide2_h.ae76a08.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/caroussel/slide2_h.jpeg
// module id = no47
// module chunks = 1